import { BLOCK_TYPES } from "../../common/index";
import { GRID_INPUT_OPTIONS, PUZZLE_OTHER } from "../Crossword/defaultValue";
const { DRAG_ARRANGE_LIST_BLOCK } = BLOCK_TYPES;

const DRAG_ARRANGE_LIST_DEFAULT_VALUE = {
    type: DRAG_ARRANGE_LIST_BLOCK,
    data: {
        [DRAG_ARRANGE_LIST_BLOCK]: {
            options: GRID_INPUT_OPTIONS(),
            correct_answer: [],
            compute_function: { is_enabled: false, value: "" },
        },
        jumpTo: {
            default: null,
            conditions: [],
        },
        other: {
            ...PUZZLE_OTHER,
            feedbacks: [], // DEFAULT_FEEDBACKS,
        },
    },
};

export default DRAG_ARRANGE_LIST_DEFAULT_VALUE;
